import styled, { css, keyframes } from 'styled-components';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
import { NAVIGATION_VIEWPORT_BREAKPOINTS } from '../../../constants';
import { NavigationActionSheet } from '../../NavigationActionSheet/NavigationActionSheet';
import { NavigationActionSheetInnerContainer } from '../../NavigationActionSheet/styles/navigation-action-sheet.styled';
/**
 * Navigation action sheet container
 */
const NAVIGATION_ACTION_SHEET_SEARCH_MAX_WIDTH = 600;
const slideInUp = keyframes `
  from {
    opacity:1;
    transform: translateY(100%);
  }

  to {
    opacity:1;
    transform: translateY(0);
  }
`;
export const navigationActionSheetSearchContainerStyles = ({ theme }) => css `
	top: ${pxToRem(theme.spacing['600'])};

	/* backdrop shadow */
	&::before {
		content: '';
		position: fixed;
		z-index: -1;
		top: 0;
		right: 0;
		width: 100vw;
		height: 100vh;
		background: ${theme.colors.base.overlaySearchWidget};
	}

	@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.lg)}) {
		position: absolute;
		height: unset;
		left: unset;
		bottom: unset;
		right: ${pxToRem(theme.spacing['300'])};
		box-shadow: none;
		max-width: ${pxToRem(NAVIGATION_ACTION_SHEET_SEARCH_MAX_WIDTH)};
	}

	${NavigationActionSheetInnerContainer} {
		padding: 0;
		border-top-left-radius: ${pxToRem(theme.borderRadius.m)};
		border-top-right-radius: ${pxToRem(theme.borderRadius.m)};
		animation: ${slideInUp} ${theme.timing['500']}ms cubic-bezier(${theme.easings.guide}) forwards;

		@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.lg)}) {
			animation: unset;
		}
	}
`;
export const NavigationActionSheetSearchContainer = styled(NavigationActionSheet) `
	${navigationActionSheetSearchContainerStyles}
`;
